/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import Fields from './Fields/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/DesignSystem/CreateNewProfessionalModal/Email"
  
}) {
  return (<React.Fragment
>
<Fields
  viewPath={`${viewPath}/Fields`}
/>
{children}
</React.Fragment>)
}